<mat-accordion>
  <mat-expansion-panel class="expansion-panel" [expanded]="step === 10" (opened)="setStep(10)">
    <p>
      <label class="mat-h2">Selecione o tipo de Documento: </label>
    </p>

    <br />
    <mat-expansion-panel-header class="custom-header">
      <mat-panel-title>
        1. Tipo de Documento
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutGap="3.0%" fxLayoutAlign="center">
      <div id="TipoDoc">
        <mat-card fxFlex="50%" class="mat-elevation-z0 max-width-card">
          <a class="pointer" (click)="redirecionarProtocoloFiscal()">
            <img mat-card-image class="img img-max-width" src="../../../assets/images/NotaFiscal.PNG" alt="Imagem NotaFiscal">
          </a>
          <mat-card-content class="card-content-text">
            <h2>Fiscais</h2>
            <h5 class="text-color">É o documento com o intuito de documentar, para fins fiscais, circulação de mercadorias ou prestação de serviços.</h5>
          </mat-card-content>
        </mat-card>
        <mat-card fxFlex="50%" class="mat-elevation-z0  max-width-card">
          <a routerLink="/protocolo-naofiscal">
            <img mat-card-image class="img img-max-width" src="../../../assets/images/NaoFiscal.PNG" alt="Imagem NãoFiscal">
          </a>
          <mat-card-content class="card-content-text">
            <h2>Não Fiscais</h2>
            <h5 class="text-color">Documentos financeiros que não são obrigatórios pela legislação vigente e emissão do documento fiscal.</h5>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <br />
    <div id="divDuvida" fxLayoutAlign="center">
      <mat-icon class="material-icons color_orange">live_help</mat-icon>&nbsp;&nbsp;
      <h3 class="mat-h3">Está com dúvida qual o tipo do seu documento?
        <a href="http://mrvnet.mrv.com.br/depts/administrativo/Lists/Avisos/Attachments/64/Instru%C3%A7%C3%B5es-Tipos-documentos-PAG-Fiscal.pdf" target="_blank" ><span class="pointer">Clique aqui.</span></a>
      </h3>
    </div>
  </mat-expansion-panel>
</mat-accordion>